import { apiFetch } from './client.js';

export async function signIn(email, password) {
  return apiFetch('/auth/signin', { method: 'POST', body: { email, password } });
}

export async function signUp(email, password) {
  return apiFetch('/auth/signup', { method: 'POST', body: { email, password } });
}
